import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { translation } from '../../types/types';
import NavbarComponent from '../Navbar/NavbarComponent';
import {Container, Row, Col, Button, InputGroup, Form, Card, Modal, Spinner } from 'react-bootstrap';
// import { useDispatch } from 'react-redux';
import './GetTranslations.css';
// import { saved } from '../../store/store';
// import { useSelector } from 'react-redux';
// import { RootState } from '../../store/store';
const GetTranslations = () => {
    const [translations, setTranslations] = useState<translation[]>([]);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [ showModal, setShowModal ] = useState<boolean>(false); 
    const [ selectedTranslationKey, setSelectedTranslationKey ] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);
    const [message, setMessage] = useState<string>('')

    // const savedd = useSelector((state: RootState) => state.saved.saved )
    // console.log('saved', savedd)
    // const dispatch = useDispatch();

    const loadUserId = () => {
        return localStorage.getItem('userId')
      }

    const userId = loadUserId();

    //console.log(userId);

   

    const getTranslations = async (userId: string) => {
        if (!userId) {
            console.error('UserId is empty. Cannot fetch translations.');
            alert('Please login to see your saved translations');
            return;
        }

        setLoading(true)
        try {
            const response = await fetch('https://suwg4eyhsj.execute-api.ap-south-1.amazonaws.com/getSavedTranslations', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify( {userId:userId} ),
            });

            const data = await response.json();
            

            if (Array.isArray(data)) {
                setTranslations(data);
                // dispatch(saved(data));
                // console.log('saved', savedd)
                setLoading(false)

            } else {
                console.error('Unexpected response format:', data);
                setTranslations([]); // Ensure translations is always an array
            }

            if(data.length === 0){
                setMessage('Please save some words to populate your Word Book.')
            }
        } catch (error) {
            console.error('Error fetching translations:', error);
            setTranslations([]); // Set to empty array on error
        }
    };


    useEffect(() => {
        if (userId) {
            
            getTranslations(userId);
        }else{
            alert('Please login to see the saved translations')
        }
    }, [userId]);


    const handleDeleteClick = (translationKey: string) => {
        setSelectedTranslationKey(translationKey);
        setShowModal(true);
    }

    const handleConfirmDelete = async() => {
        if(userId && selectedTranslationKey){
            setLoading(true)
            try{
                const response = await fetch('https://suwg4eyhsj.execute-api.ap-south-1.amazonaws.com/deleteTranslations', {
                    method: 'POST',
                    headers: {
                        'Content-type' : 'application/json',
                    },
                    body: JSON.stringify({userId: userId, translationKey: selectedTranslationKey})
                });
                if(response.ok){
                    setTranslations(translations.filter((t) => t.TranslationKey !== selectedTranslationKey));
                    alert ('Translation deleted successfully')
                    setLoading(false)
                }else{
                    alert('Failed to delete translation')
                }
            }
            catch(error){
                console.error('Error deleting translation', error)
                alert('An error occured while deleting translation')
            }
        }
        setShowModal(false);
        setSelectedTranslationKey(null);
    }

    const handleCancelDelete = () => {
        setShowModal(false);
        setSelectedTranslationKey(null);
    }

    const filteredTranslations = translations.filter(t => 
        t.Text.toLowerCase().includes(searchTerm.toLowerCase()) ||
        t.Translation.toLowerCase().includes(searchTerm.toLowerCase())
    );



    return (
        <div>
            <NavbarComponent />
            <Container style={{ marginTop: '100px' }}>
    
                {userId && (
                    <>
                        <Row className='d-flex justify-content-center mt-4'>
                            <Col className='d-flex justify-content-center'>
                                {loading && (<Spinner />)}
                            </Col>
                        </Row>

                        
    
                        {translations && translations.length > 0 ? (
                            <div>
                                <Row className='d-flex justify-content-center mt-4'>
                                    <Col className='d-flex justify-content-center'>
                                        <InputGroup>
                                            <Form.Control
                                                type='text'
                                                value={searchTerm}
                                                placeholder='Search your saved translations'
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </InputGroup>
                                    </Col>
                                </Row>
    
                                <Row className='d-flex mt-4'>
                                    {filteredTranslations.length > 0 ? (
                                        filteredTranslations.map((t, i) => (
                                            <Col md={6} lg={4} className='mb-4' key={i}>
                                                <Card className='card'>
                                                    <Card.Body>
                                                        <Card.Title>{t.Text}</Card.Title>
                                                        <Card.Text>
                                                            <ReactMarkdown>{t.Translation}</ReactMarkdown>

                                                            </Card.Text>
                                                        <div className="d-flex justify-content-center mt-3">
                                                            <Button
                                                                variant='danger'
                                                                onClick={() => handleDeleteClick(t.TranslationKey)}
                                                            >
                                                                Delete
                                                            </Button>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        ))
                                    ) : (
                                        <p>No saved translations found.</p>
                                    )}
                                </Row>
                            </div>
                        ) : (
                            <Row className='d-flex justify-content-center mt-4'>
                                <Col className='d-flex justify-content-center'>
                                {message && (<p>{message}</p>)}
                                </Col>
                            </Row>
                        )}
                    </>
                )}
    
            </Container>
    
            <Modal show={showModal} onHide={handleCancelDelete}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this translation?</Modal.Body>
                <Modal.Footer>
                    <Button variant='secondary' onClick={handleCancelDelete}>
                        Cancel
                    </Button>
                    <Button variant='danger' onClick={handleConfirmDelete}>
                        Delete
                    </Button>

                    <Row className='d-flex justify-content-center mt-4'>
                            <Col className='d-flex justify-content-center'>
                                {loading && (<Spinner />)}
                            </Col>
                        </Row>

                </Modal.Footer>
            </Modal>
        </div>
    );
    
}

export default GetTranslations;
